import React from 'react';
import { SvgIconProps } from '@mui/material';

import { SvgIcon } from '../svg-icon';

function Parcel({ ...props }: SvgIconProps): JSX.Element {
  return (
    <SvgIcon viewBox="0 0 14 14" {...props}>
      <path d="M12 10C12 10.2533 11.86 10.4733 11.6467 10.5867L6.38 13.5467C6.27333 13.6267 6.14 13.6667 6 13.6667C5.86 13.6667 5.72667 13.6267 5.62 13.5467L0.353333 10.5867C0.14 10.4733 0 10.2533 0 10V4.00001C0 3.74668 0.14 3.52668 0.353333 3.41334L5.62 0.453344C5.72667 0.373344 5.86 0.333344 6 0.333344C6.14 0.333344 6.27333 0.373344 6.38 0.453344L11.6467 3.41334C11.86 3.52668 12 3.74668 12 4.00001V10ZM6 1.76668L4.74 2.48001L8.66667 4.74001L9.97333 4.00001L6 1.76668ZM2.02667 4.00001L6 6.23334L7.30667 5.50001L3.38667 3.23334L2.02667 4.00001ZM1.33333 9.60668L5.33333 11.86V7.38668L1.33333 5.14001V9.60668ZM10.6667 9.60668V5.14001L6.66667 7.38668V11.86L10.6667 9.60668Z" />
    </SvgIcon>
  );
}

export { Parcel };
